//console.  emedia.useCurrentXService.current


var emedia = window.emedia = window.emedia || {};

var util = emedia.util = require('./components/Util');

/**
 * webpack.config.js
 *     module: {
        noParse: [/adapter.js$/],
        rules: [
            {
                test: require.resolve('zepto'),
                loader: 'exports-loader?window.Zepto!script-loader'
            }
        ]
    },
 *
 * var zepto = require("zepto");
 * // var zepto = require('exports-loader?window.Zepto!script-loader!zepto');
 *
 * 或者
 * npm install zepto-webpack
 *
 *
 */
var zepto = require("zepto-webpack");


emedia.config = function (cfg) {
    cfg = util.extend({}, cfg);

    for(var key in cfg){
        emedia.config[key] = cfg[key];
        if(key === "logLevel"){
            emedia.LOG_LEVEL = cfg[key];
        }
    }

    if(emedia.config.loglastConfrCount && !emedia._logContext){
        emedia._logContext = new Array(emedia.config.loglastConfrCount);
        emedia._logContextIndex = -1; //代表没有日志
    }
};
emedia.config({
    autoSub: true,

    onlyEnter: false,

    reconnect: 13, //重连次数
    reconnectDelay: 3000, //重连间隔 毫秒

    getCopyIntervalMillis: 30000,
    checkConnectIntervalMillis: 1000,

    iceRebuildCount: 3,
    iceRebuildIntervalMillis: 500,
    //iceWaitBuildMillis: 30000,

    enterTimeout: 20000,

    useRTCCfgIfServerReturn: false,
    forceUseRTCCfgIfServerReturnWhenP2P: true,

    allowRepeatAudioMixerPublish: false,

    logVolumeWhenInstantGE: 0.5,
    getMediaMeterIntervalMillis: 400,
    _useRequestAnimationFrame: false,

    meterWithTrackAudioLevel: false,
    judgeTalkingByInstantGE: 0.05,

    _printSoundData: false,

    trackBufferSize: 20,
    allowSendWhenLessThan: 4,
    disableTrack: false,

    ctrlCheckIntervalMillis: 10 * 1000,
    ctrlTimeoutMillis: 30 * 1000,

    _printDebugStats: false,
    statsSeconds: 10,
    remainLastStatsCount: 120,
    //wsorigin

    loglastConfrCount: 2,
    loglastStoreArray: true,
    consoleLogger: true,

    printStatsWhenPCClose: true,

    rebuildPeerConnectionWhenNetworkChanaged: true,
    useDeployMore:false,
    useDTX:true, // 开启 DTX
    uploadStats:true, // 开启 数据上报
    liveCfgs:[], // 多路推流数组
    rtcStatsTypeMath: function (_stat, name) {
        switch(_stat.type){
            case "remote-candidate":
            case "local-candidate":
            case "track":
            case "stream":
            case "inbound-rtp":
            case "outbound-rtp":
            case "transport":
                return true;
        }
        return false;
    }

    // forceUseVideoCodecs: [],
    // forceUseAudioCodecs: [],
    // forceVideoBitrate: ,
    // forceAudioBitrate: ,
});

util.logger.count();
//util.logger.info(navigator.userAgent);

(function requireWebrtcAdapter() {
    var adapter = require('./_adapter/_Adapter.import').default;
    emedia.browser = adapter.__browser; // firefox chrome safari IE
    emedia.browserVersion = adapter.__browserVersion;

    if(emedia.browser === undefined){
        throw "Not discern browser. may require adapter error. eg. it.default"
    }
})();
util.logger.info("Current browser", emedia.browser, emedia.browserVersion);


emedia.AudioContext = window.AudioContext || window.webkitAudioContext;

if(emedia.config.getMediaMeterIntervalMillis){
    // https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11/46534088#46534088
    // There are two problems.
    // The main one is that Safari on iOS 11 seems to automatically suspend new AudioContext's that aren't created in response to a tap.
    // You can resume() them, but only in response to a tap.
    //
    // So, you have to either create it before you get the MediaStream, or else get the user to tap again later.
    try {
        if (typeof emedia.AudioContext === 'function') {
            emedia.__audioContext = new emedia.AudioContext();
            emedia.__usingWebAudio = true;
        }else{
            emedia.__usingWebAudio = false;
        }
    } catch(e) {
        emedia.__usingWebAudio = false;
    }

    // context state at this time is `undefined` in iOS8 Safari
    if (emedia.__usingWebAudio && emedia.__audioContext.state === 'suspended') {
        zepto(function(){
            var resume = function () {
                (emedia.__audioContext.state === 'suspended') && emedia.__audioContext.resume();
                util.logger.warn("AudioContext state suspended ->", emedia.__audioContext.state);

                setTimeout(function () {
                    if (emedia.__audioContext.state === 'running') {
                        document.body.removeEventListener('touchend', resume, false);
                        document.body.removeEventListener('click', resume, false);
                    }
                }, 0);
            };

            document.body.addEventListener('touchend', resume, false);
            //document.body.addEventListener('load', resume, false);
            document.body.addEventListener('click', resume, false);
        });
    }

    if(!emedia.__usingWebAudio){
        console.warn("'new AudioContext()' failed. can not know who talking.");
    }
    if(emedia.__audioContext && emedia.__audioContext.state === 'suspended'){
        console.warn("audioContext.state is suspended. can not know who talking. You can resume() emedia.__audioContext, but only in response to a tap.");
    }
}


if (!window.requestAnimationFrame || !emedia.config._useRequestAnimationFrame) {
    emedia.requestAnimationFrame = function(fn, timeoutMillis) {
        return setTimeout(fn, timeoutMillis || emedia.config.getMediaMeterIntervalMillis);
    };
}else{
    emedia.requestAnimationFrame = function(callback){
        window.requestAnimationFrame(callback);
    }
}

if (!window.cancelAnimationFrame || !emedia.config._useRequestAnimationFrame) {
    emedia.cancelAnimationFrame = function(id) {
        clearTimeout(id);
    };
}else{
    emedia.cancelAnimationFrame = function(id){
        window.cancelAnimationFrame(id);
    }
}


emedia.isWifi = function isWifi() {
    try {
        var wifi = true;
        var ua = window.navigator.userAgent;
        var con = window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection;
        // 如果是微信
        if (/MicroMessenger/.test(ua)) {
            if (ua.indexOf('WIFI') >= 0) {
                return true;
            }else{
                wifi = false
            }

        } else if (con) { //navigator.connection //type: unknown, ethernet, wifi, 2g, 3g, 4g, none.
            var network = con.type;
            if (network !== 'wifi' && network !== '2' && network !== 'unknown') {
                wifi = false
            }
        }
        return wifi;
    } catch (e) {
        return false
    }
};


emedia.stopAudioTracks = function (_stream) {
    _stream && _stream.getAudioTracks().forEach(function (track) {
        track.stop();
        util.logger.info("Media stream stop audio track. stream =", _stream.id, "track =", track.id, track.kind);
    });
};
emedia.stopAndRemoveAudioTracks = function (_stream) {
    var tracks = [];
    _stream && _stream.getAudioTracks().forEach(function (track) {
        track.stop();
        tracks.push(track);
        util.logger.info("Media stream stop and remove audio tracks. stream =", _stream.id, "track =", track.id, track.kind);
    });

    util.forEach(tracks, function (_index, track) {
        _stream.removeTrack(track);
    });
};

emedia.stopTracks = function (_stream) {
    try{
        if(!_stream || _stream.active === false){
            util.logger.debug("stream tracks had been stoped. it ", _stream && _stream.id);
            return;
        }

        function stop() {
            _stream.getTracks().forEach(function (track) {
                track.stop();
                util.logger.info("Media stream stop track. stream =", _stream.id, " track =", track.id, track.kind);
            });

            if(_stream._bindAttendee){
                //push stream时，由于异步，在未返回成功后，退出会议，摄像头不会被关闭问题
                util.removeAttribute(_stream._bindAttendee._openedRtcMediaStreams, _stream.id);
                _stream._bindAttendee = null;
            }
            util.logger.info("stream tracks stoped. it ", _stream.id);
        }
        stop();
        //setTimeout(stop, 300);
    }catch (e) {
        util.logger.error(e);
    }
};

emedia.enableVideoTracks = function (_stream, enabled) {
    _stream && _stream.getVideoTracks().forEach(function (track) {
        if(typeof track.enable === "function"){
            track.enable();
            util.logger.info("Media stream enable video track. stream =",
                _stream.id, "track =", track.kind, track.enabled, track.id);
            track.enabled === enabled || track.enable(enabled);
            return;
        }

        track.enabled === enabled || (track.enabled = enabled);
        util.logger.info("Media stream enable video track. stream =",
            _stream.id, "track =", track.kind, track.enabled, track.id);
    });
};

emedia.enableAudioTracks = function (_stream, enabled) {
    _stream && _stream.getAudioTracks().forEach(function (track) {
        if(typeof track.enable === "function"){
            track.enable();
            util.logger.info("Media stream enable audio track. stream =",
                _stream.id, "track =", track.kind, track.enabled, track.id);
            track.enabled === enabled || track.enable(enabled);
            return;
        }

        track.enabled === enabled || (track.enabled = enabled);
        util.logger.info("Media stream enable audio track. stream =",
            _stream.id, "track =", track.kind, track.enabled, track.id);
    });
};

emedia.hasEnabledTracks = function (mediaStream) {
    if(!mediaStream || (typeof mediaStream.getAudioTracks !== 'function')){
        return false;
    }

    if(!mediaStream.active){
        return false;
    }

    var tracks = mediaStream.getAudioTracks();

    if(tracks.length === 0){
        return false;
    }

    for(var i in tracks){
        if(typeof tracks[i].enable === "function"){
            tracks[i].enable();
        }
        if(tracks[i].enabled){
            return true;
        }
    }

    return false;
};


emedia.genReportName = function(){

    var date = (emedia._lastSetupDate || (new Date()));
    //date = date.toLocaleString().replace(/[\/\s]/g, '-');
    return (emedia._lastSetupTktId || emedia._lastSetupConfr)
        + "_" + emedia._lastSetupMemName
        + "_" + date.getTime()
        + ".log";
};

emedia.getReportUploadUrl = function(method, url, cb){
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.addEventListener('load', function (response) {
        cb && cb(response);
    },false);

    xhr.send(null);
};

emedia.uploadReport = function(fileName, url, commitData, success, error, addHeader){
    var fileContent = emedia.genReport();
    if(!fileContent){
        error && error("not logs");
        return;
    }

    if(typeof commitData === "function"){
        addHeader = error;
        error = success;
        success = commitData;
        commitData = undefined;
    }

    function onUploadFile(response) {
        console.info("log begin upload. result = ", response.currentTarget.status, fileName, " > ", url);

        if (response.currentTarget.status === 200) {
            //response.currentTarget.getResponseHeader('response-text');
            success && success(response);
        } else {
            //this.reportError = response.currentTarget.status;
            error && error(response);
        }
    }

    // Create report file.
    var blob = new Blob([fileContent], {type: 'text/plain'});
    var formData = new FormData();
    formData.append(fileName, blob, fileName);
    if(commitData && typeof formData.set === "function"){
        util.forEach(commitData, function (key, value) {
            formData.set(key, value);
        });
    }

    // Upload the report file using the URL in the response-text header.
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    
    xhr.setRequestHeader('X-File-Name', fileName);
    addHeader && addHeader(xhr);
    xhr.addEventListener('load', onUploadFile, false);
    xhr.send(formData);

    console.info("log begin upload. ", fileName, " > ", url)
};

emedia.genReport = function(){
    if(!emedia._logContext){
        return;
    }
    if(!(emedia._logContext instanceof Array)){
        return;
    }
    if(typeof emedia._logContextIndex === 'undefined' || emedia._logContextIndex < 0){
        return;
    }

    var start = 0;
    var end = emedia._logContextIndex;
    if(emedia._logContextIndex >= emedia._logContext.length){
        start = emedia._logContextIndex - emedia._logContext.length + 1;
    }

    var report = "";
    for(var i = start; i <= end; i++){
        var index = i % emedia._logContext.length;
        var oneConfrLogs = emedia._logContext[index];
        report += oneConfrLogs.join("\r\n") + "\r\n";
    }

    if(emedia._logContext.loadlogs && emedia._logContext.loadlogs instanceof Array){
        report += "-------------------------------------------------------------\r\n";
        report += emedia._logContext.loadlogs.join("\r\n") + "\r\n";
    }

    return report;
};

emedia.fileReport = function (filename, exception) {
    var fileContent = emedia.genReport();
    if(!fileContent){
        return;
    }

    if(exception){ //遇到的异常加到日志
        fileContent = `遇到的异常描述如下：\r\n ${exception} \r\n ${fileContent}`
    }


    var content = encodeURIComponent(fileContent);

    var link = document.createElement('a');
    link.style.display = 'none';
    link.download = filename || 'emedia-' + (new Date().toJSON()) + '.log';
    link.href = 'data:text/plain;charset=utf-8,' + content;
    //link.setAttribute('download', link.download);
    //link.setAttribute('href', 'data:text/plain;charset=utf-8,' + content); //'data:attachment/file;charset=utf-8,' + content

    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

if(navigator.mediaDevices){
    var supportedConstraints = navigator.mediaDevices.getSupportedConstraints();
    util.logger.info("Supported constraints", supportedConstraints);
}


emedia.config({
    globalConstraints:{
        // audio:{
        //
        // }
    }
});


var Service = require('./components/Service');
var __event = require('./components/event');

emedia.Webrtc = require('./components/_Webrtc');

emedia.Service = Service;
emedia.P2P = require('./components/AddonsP2P');
// var cloneService = util.extend({}, Service).extend(Service);
emedia.XService = Service;
emedia.XServiceWithP2P = emedia.P2P(Service);

// emedia.mgr = require("./components/mgr/Manager");
// emedia.mgr = emedia.mgr.single;
emedia.mgr = require("./components/mgr/outer").outer;

emedia.ctrl = require('./components/pannelVideo');
emedia.CompositeCanvas = require('./components/CompositeCanvas');

emedia.pannel || (emedia.pannel = {});
emedia.pannel.DefaultMouseTrack = require('../../pannel/src/components/DefaultTrack');
emedia.pannel.MouseTrack = require('../../pannel/src/components/MouseTrack');
emedia.pannel.KeyboardTrack = require('../../pannel/src/components/KeyboardTrack');

var PCStats = emedia.PCStats = require('./components/PCStats');

emedia.helper = emedia.helper || {};

emedia.helper.PCStats = PCStats;

emedia.helper.pcstats = PCStats.echo;
emedia.helper.intervalPcstats= PCStats.intervalEcho;

emedia.helper.inboundAudio = PCStats.inboundAudio;
emedia.helper.inboundVideo = PCStats.inboundVideo;

emedia.helper.outboundAudio = PCStats.outboundAudio;
emedia.helper.outboundVideo = PCStats.outboundVideo;


emedia.event = __event;


emedia.LOG_LEVEL = 0;

emedia.isFirefox = 'firefox' === emedia.browser;
emedia.isChrome = 'chrome' === emedia.browser;
emedia.isSafari = 'safari' === emedia.browser;
emedia.isEdge = 'edge' === emedia.browser;

emedia.isElectron = /Electron/.test(navigator.userAgent);
if(emedia.isElectron){
    try{
        require("./components/electron");
    }catch(e){
        util.logger.error(e)
    }
}

emedia.youInSomeBrowsers = function(){
    //return emedia.isSafari;
        //|| (emedia.isChrome && emedia.browserVersion >= 75);

    if(emedia.isSafari){
        // return true;
        // safari 从13起，不在需要先打开摄像头获取权限，后再去订阅了, webrtc 可以生成canidata了
        // 但是只有audio时 订阅成功但是无法播放声音，还是需要先去getUserMedia下
        var reg = new RegExp("(Version)/([0-9\.]+)", "i");
        var r = navigator.userAgent.match(reg);
        if (r != null) {
            var version = unescape(r[2]);
            version = parseInt(version);

            return version < 13;
        }
    }

    return false;
};

//candidate:3 1 UDP 2013266431 116.62.36.187 31574 typ host
//candidate:4006386702 1 udp 41819903 39.107.152.84 33631 typ relay raddr 0.0.0.0 rport 0 generation 0 ufrag zOjH network-id 1 network-cost 10
emedia.replaceIpAndPortOfCandidate = function(candidate, ip, port){
    var str = typeof candidate === "string" ? candidate : candidate.candidate;
    str = str.replace(/(candidate:\d+\s+\d+\s+udp\s+\d+\s+)([\d\.]+)\s+(\d+)(\s+.*)/g, function (all, $pre, $ip, $port, $after) {
        // console.log(all);
        // console.log(pre, ip, port, after);
        return $pre + ip + " " + port + $after;
    });

    if(candidate.candidate){
        candidate = util.extend(true, {}, candidate);
        candidate.candidate = str;
    }else{
        candidate = str;
    }
    return candidate;
};
emedia.replaceIpAndPort = function(candidate, cb){
    if(typeof cb !== 'function'){
        return candidate;
    }

    var str = typeof candidate === "string" ? candidate : candidate.candidate;
    str = str.replace(/(candidate:\d+\s+\d+\s+udp\s+\d+\s+)([\d\.]+)\s+(\d+)(\s+.*)/g, function (all, $pre, $ip, $port, $after) {
        var newIpPort = cb($ip, $port);
        if(typeof newIpPort === 'string'){
            newIpPort = newIpPort.replace(':', ' ');
            return  $pre + newIpPort + $after;
        }
        return $pre + $ip + " " + $port + $after;
    });

    if(candidate.candidate){
        candidate = util.extend(true, {}, candidate);
        candidate.candidate = str;
    }else{
        candidate = str;
    }
    return candidate;
};

emedia.replaceURL = function(wsUrl, cb){
    if(typeof cb !== 'function'){
        return wsUrl;
    }

    return wsUrl.replace(/([^:\/?&#=]+):\/\/([^\/:?#]+)(:\d+)?(\/[^?#]*)?(\?[^\/#]*)?(#[^\/?]*)?/g, function (all, $protocol, $host, $port, $path, $query, $fragment) {
        if($port){
            $port = $port.substring(1);
        }

        var url = cb(all, $protocol, $host, $port, $path, $query, $fragment);
        if(!url){
            return wsUrl;
        }
        if(typeof url === 'string'){
            return  url;
        }

        var protocol = url.protocol || $protocol;
        var host = url.host || $host;
        var port = url.port || $port;
        var path = url.path || $path;
        var query = url.query || $query;
        var fragment = url.fragment || $fragment;

        return protocol
            + "://" + host
            + (port ? (":" + port) : "")
            + (path ? path : "")
            + (query ? query : "")
            + (fragment ? fragment : "");
    });
};

emedia.requireTrustBeforeJoin = function(){
    //return (/windows|win32/i.test(navigator.userAgent) && emedia.isChrome && emedia.browserVersion >= 75);
    return false;
};

emedia.isWebRTC = window.RTCPeerConnection && /^https\:$/.test(window.location.protocol);

/**
 * 判断是否支持pranswer
 */
if (emedia.isChrome || emedia.isSafari) {
    emedia.supportPRAnswer = true;
}
/**
 * 2019.02.21
 * 发现chrome72版本 对pranswer支持有问题，https://webrtc.github.io/samples/src/content/peerconnection/pr-answer 事例也不能正显示视频
 * video.srcObject [remote media stream] active: false.
 *
 * 统一设置为不支持pranswer
 *
 */
emedia.supportPRAnswer = false;


emedia.config({
   baseAcptOps: [
       102, 104, 105, 106, 107, 300, 302, 303, 304, 301, 
       204, 206, 400, 401, 1001, 100221, 100222, 100223,
       100224,100201,100202, 100203
    ]
    // baseAcptOps: [107, 300, 302, 303, 304, 301, 204, 206, 400, 401, 1001]
});
emedia.config({
    clientType: 'WEB',
    version: '3.2.2',

    userAgent: navigator.userAgent,

    acptOps:[
        100230, //远程控制
        100205, //远程抓图
        1003, //透传消息
        1004,  //P2P消息支持
        // 100201, //缩放
        // 100202, //聚焦
        // 100203, //曝光
        // 100204, //定格
        // 100205 //远程抓图
    ]
});

// emedia.config({
//     reconfigRTCConfiguration: function(iceServerConfig){
//         window.coturnIp || (window.coturnIp = "39.105.132.217");
//         iceServerConfig.iceTransportPolicy = 'relay';
//         iceServerConfig.iceServers && emedia.util.forEach(iceServerConfig.iceServers, function(_i, iceServer){
//             iceServer.url = "turn:" + window.coturnIp + ":3478";
//         });
//         return iceServerConfig;
//     },
//     reChanageCandidate: function (candidate) {
//         // return emedia.replaceIpAndPortOfCandidate(candidate, "121.41.55.114", 41111);
//         //或者
//         return emedia.replaceIpAndPort(candidate, function(ip, port){ //ip, port是从 candidate中解析出来的
//             // if(ip === '39.107.157.65'){
//             //     ip = '10.66.204.222';
//             // }
//             // if(ip === '39.107.152.84'){
//             //     ip = '10.66.178.216';
//             // }
//             if(ip === '39.105.132.217'){
//                 ip = '172.16.0.69';
//             }
//             if(ip === '39.97.115.231'){
//                 ip = '172.16.0.105';
//             }
//             // if(port == 1234){
//             //     port = 新端口replaceIpAndPortOfCandidate
//             // }
//             return ip + ":" + port;
//         });
//     }
// });


// /**
//  *  Enter 客户端携带，进入
//  *  服务端可支持，Json字符串，或Json数据
//  */
// var res = {
//     type: 'ios|android|web',
//     ver: '1.0.2',
//     agent: '', //ios android可以不传，web navigator.userAgent
//     //可缺省，缺省默认支持
//     //107 300 302 303 304 301 204 206 400 401 1001
//     ops:[
//         1003, //透传消息
//         100201, //缩放
//         100202, //聚焦
//         100203, //曝光
//         100204, //定格
//         100205 //远程抓图
//     ],
//
//     vcodes:['H264', 'VP8'] //客户端进入，可以携带，也可以不携带。携带了，就使用这个广播给其他人。
//                            // A进入，没有携带此参数，服务端通过 type ver agent 补全此字段，广播给B C
// }


module.exports =  emedia;